/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Conflict, Email, Forbidden, NotFound, Success, SuccessList, Unauthorized } from "./data-contracts";
import { FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "tenant";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @name GetApiV1Tenants
   * @request GET:/v1/tenants
   */
  getApiV1Tenants = (
    query: {
      /** @pattern .+@.+ */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<SuccessList, Email | Conflict>({
      path: `/v1/tenants`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1Tenants */
  getApiV1TenantsPathGetter = (query: {
    /** @pattern .+@.+ */
    email: string;
  }) => this.getServicePath(`/v1/tenants`, query);

  /**
   * No description
   *
   * @name GetApiV1PublicTenants
   * @request GET:/v1/public/tenants
   */
  getApiV1PublicTenants = (
    query: {
      /** @pattern [\w-]{1,2000} */
      subdomain: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<SuccessList, Email | Conflict>({
      path: `/v1/public/tenants`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1PublicTenants */
  getApiV1PublicTenantsPathGetter = (query: {
    /** @pattern [\w-]{1,2000} */
    subdomain: string;
  }) => this.getServicePath(`/v1/public/tenants`, query);

  /**
   * No description
   *
   * @name GetApiV1TenantsTenantid
   * @request GET:/v1/tenants/{tenantId}
   */
  getApiV1TenantsTenantid = (tenantId: string, params: RequestParams = {}) =>
    this.request<Success, Email | Unauthorized | Forbidden | NotFound | Conflict>({
      path: `/v1/tenants/${tenantId}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getApiV1TenantsTenantid */
  getApiV1TenantsTenantidPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenants/${tenantId}`);

  /**
   * No description
   *
   * @name DeleteApiV1TenantsTenantid
   * @request DELETE:/v1/tenants/{tenantId}
   * @secure
   */
  deleteApiV1TenantsTenantid = (tenantId: string, params: RequestParams = {}) =>
    this.request<Success, Email | Unauthorized | Forbidden | NotFound>({
      path: `/v1/tenants/${tenantId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteApiV1TenantsTenantid */
  deleteApiV1TenantsTenantidPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenants/${tenantId}`);
}
